import React, {FC} from "react"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Pill from "@irati/ui/src/Pill"
import theme from "@irati/ui/src/global/theme"
import {IconTypes} from "@irati/ui/src/Icon"
import adminTracking from "@irati-tracking/admin"
import {AUTOMATION_BASE} from "@irati-web/admin/src/routes/routeConfig"

import {NewPillWrapper, RelativeDiv} from "../styled"
import AdminRouterLink from "./AdminRouterLink"

interface Props extends InjectIntl {
  isCollapsed: boolean
}

const AutomationAdminRouterLink: FC<Props> = ({isCollapsed, formatMessage}) => {
  return (
    <RelativeDiv>
      <AdminRouterLink
        id="automationPageButton"
        isCollapsed={isCollapsed}
        to={AUTOMATION_BASE}
        icon={IconTypes.automation}
        onClick={adminTracking.navigationClickAutomation}
        title="platform.adminNavigation.primary.automation"
      />
      {!isCollapsed && (
        <NewPillWrapper>
          <Pill text={formatMessage({id: "platform.new.label"})} backgroundColor={theme.colors.perkbox.blue} isWhiteText />
        </NewPillWrapper>
      )}
    </RelativeDiv>
  )
}

export default injectIntl(AutomationAdminRouterLink)
